import styled from 'styled-components'

export const HomeStyle = styled.div`
    padding-top: 0 !important ;
    background-color: ${(props) => props.theme.colors.colorBgLayout};
`
